import { Config } from '@leverege/plugin';
import { Attributes } from '@leverege/ui-attributes';
import Path from '@leverege/path';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('pairing.pairing.util.Relationship');
const slashToDot = path => path.replace(/\//g, '.');
export function isAssetPaired(asset, relationship) {
  const tagId = getTagIdFromAsset(asset, relationship);
  return tagId != null;
}
export function isTagPaired(tag, relationship) {
  const assetId = getAssetIdFromTag(tag, relationship);
  return assetId != null;
}
export function getPairingMetadata(relationship) {
  return relationship?.attribute?.metadata?.pairing;
}
export function getTagFromAsset(asset, relationship) {
  const path = relationship.attribute.path;
  return Path.get(`data/${path}`, asset.data);
}
export function getAssetBlueprintName(relationship) {
  return relationship.parentBlueprint.name;
}
export function getTagBlueprintName(relationship) {
  return relationship.blueprint.name;
}
export function getAssetBlueprintNamePlural(relationship) {
  return relationship.parentBlueprint.namePlural;
}
export function getTagBlueprintNamePlural(relationship) {
  return relationship.blueprint.namePlural;
}
export function getAssetType(relationship) {
  return relationship.parentBlueprint.type;
}
export function getTagType(relationship) {
  return relationship.blueprint.type;
}
export function getPairNavIcon(relationship) {
  const icon = relationship?.attribute?.metadata?.pairing?.pairNavIcon;
  return Config.get('Pairing', 'pairNavIcon', icon || 'https://recovr-ui-assets.storage.googleapis.com/pair_button_icon.png');
}
export function getTagNetwork(relationship) {
  const network = relationship.blueprint.getTagStartingWith('pairingNetwork:', true) || relationship.blueprint.getTagStartingWith('network:', true);
  if (network) {
    const [networkId, aliasKey] = network.split(':');
    return {
      networkId,
      aliasKey: aliasKey || 'deviceId'
    };
  }
  return null;
}
export function getUnpairNavIcon(relationship) {
  const icon = relationship?.attribute?.metadata?.pairing?.unpairNavIcon;
  return Config.get('Pairing', 'unpairNavIcon', icon || 'https://recovr-ui-assets.storage.googleapis.com/unpair_button_icon.png');
}
export function getTagIdFromAsset(asset, relationship) {
  const path = relationship?.attribute?.path;
  return Path.get(`data/${path}/id`, asset, Path.get(`data/data/${path}/id`, asset));
}
export function getAssetIdFromTag(tag, relationship) {
  const childPath = relationship?.attribute?.model?.childPath;
  if (childPath) {
    return Path.get(`data/${childPath}/id`, tag?.data, null);
  }
  return null;
}
export function getPairTitle(relationship) {
  const {
    blueprint,
    parentBlueprint
  } = relationship;
  const assetName = parentBlueprint.name;
  const tagName = blueprint.name;
  return t('pairTitle', {
    tagName,
    assetName
  });
}
export function getUnpairTitle(relationship) {
  const {
    blueprint,
    parentBlueprint
  } = relationship;
  const assetName = parentBlueprint.name;
  const tagName = blueprint.name;
  return t('unpairTitle', {
    tagName,
    assetName
  });
}